const WALLET_DATA_CHANGED_EVENT = "capone:wallet-data-changed";

const getWalletRefreshKey = (source: string, bookingId: string) =>
  `wallet-refresh:${source}:${bookingId}`;

export const notifyWalletDataChanged = (source: string, bookingId: string) => {
  const refreshKey = getWalletRefreshKey(source, bookingId);

  if (window.sessionStorage.getItem(refreshKey) === "1") {
    return;
  }

  window.sessionStorage.setItem(refreshKey, "1");
  window.dispatchEvent(new Event(WALLET_DATA_CHANGED_EVENT));
};
